import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4',
    width:"100%"
    },
    section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
    },
    company_name: {
        Font:'Arial',
        fontWeight:900,
        fontSize:25
    },
    company_adress: {
        Font:'Arial',
        fontSize:25
    },
    paddingTop10:{
        paddingTop:10
    },
    cell: {
        marginRight:10,
        textAlign:"right"
    },
    tableRow:{
        display: 'flex',
        flexDirection: 'row',
    },
    col1:{
        display: 'flex',
        flexDirection: 'row',
        width:55
    },
    col2:{
        display: 'flex',
        flexDirection: 'row',
        width:30
    },
    col3:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col4:{
        display: 'flex',
        flexDirection: 'row',
        width:70
    },
    col5:{
        display: 'flex',
        flexDirection: 'row',
        width:70
    },
    floatright:{
        alignItems:"flex-end"
    },
    colComputations1:{
        width:255
    },
    colComputations2:{
        width:70
    },
    row:{
        display: 'flex',
        flexDirection: 'row',
    },
    textcenter:{
        textAlign:"center"
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize:6
    },
});

export function PdfDocumentFS(props) {
    // console.log(props);
    return (
        <Document>
            <Page size="Letter" style={styles.page} orientation="portrait" wrap>
                <View style={styles.section}>
                    {/* Package Sales Information */}
                    {/* Date */}
                    <Text style={styles.company_name}>Date:{props.headers.date}</Text>
                    {/* Sold To */}
                    <Text style={styles.company_name}>Sold To:{props.headers.soldto}</Text>
                    {/* Package */}
                    <Text style={styles.company_name}>ID No.: {props.headers.idno}</Text>
                    {/* Reference No. */}
                    <Text style={styles.company_name}>Pin No.:{props.headers.pinno}</Text>
                    {/* Location */}
                    <Text style={styles.company_name}>Activation No.:{props.headers.actno}</Text>

                    {/* Item Details */}
                    <View style={[styles.tableRow,styles.paddingTop10]}>
                        <View style={[styles.tableRow,styles.col1]}>
                            <Text style={[styles.company_adress,styles.cell]}>Qty</Text>
                        </View>
                        <View style={[styles.tableRow,styles.col2]}>
                            <Text style={[styles.company_adress,styles.cell]}>Unit</Text>
                        </View>
                        <View style={[styles.tableRow,styles.col3]}>
                            <Text style={[styles.company_adress,styles.cell]}>Description</Text>
                        </View>
                        <View style={[styles.tableRow,styles.col4]}>
                            <Text style={[styles.company_adress,styles.cell]}>Price</Text>
                        </View>
                        <View style={[styles.tableRow,styles.col5]}>
                            <Text style={[styles.company_adress,styles.cell]}>Total</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
};